import {lazy} from "react";

/**
 * 静态路由表（混合方案：路由静态化，菜单/权限仍由 sys_resources 动态驱动）
 * 数据来源：sys_resources 中 is_disabled=0 且有 component_path 的记录
 * 新增页面需同时：1) 在此表添加条目  2) 在"资源管理"后台添加菜单记录
 */
export const routeConfig = [
    // ===== 首页 / 日历 =====
    {path: "/", component: lazy(() => import("../../containers/calendar/calendar"))},
    {path: "/calendar/week", component: lazy(() => import("../../containers/calendar/calendar-week"))},

    // ===== 教务管理 =====
    {path: "/affairs/classes", component: lazy(() => import("../../containers/affairs/classes/classes"))},
    {path: "/affairs/students", component: lazy(() => import("../../containers/affairs/students/students"))},
    {path: "/affairs/photos", component: lazy(() => import("../../containers/affairs/photos/photos"))},
    {path: "/affairs/dianping", component: lazy(() => import("../../containers/affairs/dianping/dianping"))},

    // ===== 教学管理 =====
    {path: "/teaching/courses", component: lazy(() => import("../../containers/teaching/courses/courses"))},
    {path: "/teaching/tasks", component: lazy(() => import("../../containers/teaching/tasks/tasks"))},
    {path: "/teaching/documents", component: lazy(() => import("../../containers/teaching/documents/documents"))},
    {path: "/teaching/scratchs", component: lazy(() => import("../../containers/teaching/scratchs/scratchs"))},
    {path: "/teaching/challenges/python", component: lazy(() => import("../../containers/teaching/challenges/challenges"))},
    {path: "/teaching/questions", component: lazy(() => import("../../containers/teaching/questions/index"))},
    {path: "/teaching/papers", component: lazy(() => import("../../containers/teaching/papers/index"))},
    {path: "/teaching/exams", component: lazy(() => import("../../containers/teaching/exam/index"))},
    {path: "/teaching/problems", component: lazy(() => import("../../containers/teaching/cppproblem/problems"))},
    {path: "/teaching/contest", component: lazy(() => import("../../containers/teaching/contest/contest_list"))},
    {path: "/teaching/training", component: lazy(() => import("../../containers/teaching/training/training_list"))},

    // ===== 系统设置 =====
    {path: "/settings/teachers", component: lazy(() => import("../../containers/settings/teachers/teachers"))},
    {path: "/settings/wx_access_token", component: lazy(() => import("../../containers/settings/wx_access_token/wx_access_token"))},
    {path: "/settings/sys_dict_type", component: lazy(() => import("../../containers/settings/sys_dict_type/sys_dict_type"))},
    {path: "/settings/wxauth", component: lazy(() => import("../../containers/settings/wx_auth/wx_auth"))},
    {path: "/settings/resources", component: lazy(() => import("../../containers/settings/resources/resources"))},
    {path: "/settings/roles", component: lazy(() => import("../../containers/settings/roles/roles"))},
    {path: "/settings/logs", component: lazy(() => import("../../containers/settings/logs/logs"))},

    // ===== 统计 =====
    {path: "/stat", component: lazy(() => import("../../containers/stat/stat"))},

    // ===== 详情/子页面（带参数）=====
    {path: "/affairs/classes/:classes_id", component: lazy(() => import("../../containers/affairs/classes/classes_detail"))},
    {path: "/affairs/students/:student_id", component: lazy(() => import("../../containers/affairs/student/detail"))},
    {path: "/teaching/courses/:id", component: lazy(() => import("../../containers/teaching/courses/lessons"))},
    {path: "/teaching/challenges/python/create", component: lazy(() => import("../../containers/teaching/challenges/challenges_add"))},
    {path: "/teaching/challenges/python/:id/edit", component: lazy(() => import("../../containers/teaching/challenges/challenges_edit"))},
    {path: "/teaching/papers/:id", component: lazy(() => import("../../containers/teaching/papers/paper_edit"))},
    {path: "/teaching/exams/:id", component: lazy(() => import("../../containers/teaching/exam/detail"))},
    {path: "/teaching/problems/add", component: lazy(() => import("../../containers/teaching/cppproblem/problem_add"))},
    {path: "/teaching/problems/:id", component: lazy(() => import("../../containers/teaching/cppproblem/problem_edit"))},
    {path: "/teaching/problems/:id/testcases", component: lazy(() => import("../../containers/teaching/cppproblem/testcases_edit"))},
    {path: "/teaching/contest/:id", component: lazy(() => import("../../containers/teaching/contest/contest_detail"))},
    {path: "/teaching/training/:id", component: lazy(() => import("../../containers/teaching/training/training_detail"))},

    // ===== 统计/批卷/完成情况 =====
    {path: "/teaching/exams/:id/stat", component: lazy(() => import("../../containers/teaching/exam/stat"))},
    {path: "/teaching/exam/pigai", component: lazy(() => import("../../containers/teaching/exam/pigai"))},
    {path: "/teaching/problemsuser", component: lazy(() => import("../../containers/teaching/cppproblemuser/cppproblemusers"))},
    {path: "/teaching/papersusers", component: lazy(() => import("../../containers/teaching/papersusers/papersusers"))},
    {path: "/teaching/knowledge-graph", component: lazy(() => import("../../containers/teaching/knowledge-graph/knowledge-graph"))},

    // ===== 文档添加/编辑（保留 document_edit 全局路由）=====
    {path: "/teaching/documents/add", component: lazy(() => import("../../containers/teaching/documents/document_edit"))},
    {path: "/teaching/documents/:id", component: lazy(() => import("../../containers/teaching/documents/document_edit"))},
];
